import VueFlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import type { App } from 'vue'

const initVueFlatPickr = (app: App<Element>) => {
  app.component('flatPickr', VueFlatPickr)
}

export default initVueFlatPickr
